import Checkmark from '@atom-web/icons-24/jsx/Checkmark'
import Flag from '@atom-web/icons-24/jsx/Flag'
import Google from '@atom-web/icons-24/jsx/Google'
import Plus from '@atom-web/icons-24/jsx/Plus'
import Star from '@atom-web/icons-24/jsx/Star'
import { Box, Column, Row, Stack, Text } from '@atom-web/micros'
import React from 'react'
import { useContext, useMemo } from 'react'

import { ImageSlider } from '../../features/maldives/pre-costed/components/ImageSlider'
import { ListWithShowMore } from '../../features/packages/cards/ListWithShowMore'
import AppContext from '../../store/AppContext'
import enumToString from '../../utils/enumToString'
import plural from '../../utils/plural'
import Pricecomponent from './pricecomponent'
import RibbonComponent from './ribbon-component'
import SalesIncentive from './SalesIncentive'

function Card({
	resortName,
	resortCode,
	images,
	starRating,
	availableVillaTypes,
	pills,
	flightIncludes,
	transfers,
	startsAtPrice,
	strikedCost,
	onPress,
	tags = [],
	ind,
	isIxigoPartnersSite,
	activities,
	packageListingPage = false,
	displayCurrency,
	nights = 4,
	itineraryCost,
	campaignItineraryId,
	hasIncentive,
	currentResortCode,
	paxCount,
}) {
	const recommended = tags.indexOf('recommended-for-you') > -1 ? true : false
	const speedBoat = transfers.indexOf('SPEEDBOAT') > -1 ? true : false
	const seaPlane = transfers.indexOf('SEAPLANE') > -1 ? true : false
	const [{ userDetails }] = useContext(AppContext)
	const isAdmin = useMemo(() => {
		return userDetails && userDetails.userType === 'ADMIN'
	}, [userDetails])

	const InclusionText = ({ text }) => {
		return (
			<Text
				css={{
					color: '$grey07',
					fontWeight: '$bold',
					fontSize: '$2',
					lineHeight: '$2',
					letterSpacing: '0.02em',
				}}
			>
				<Checkmark width={'16px'} height={'16px'} fill="#00B277" />
				{text}
			</Text>
		)
	}
	const updatedResortName = /maldives/i.test(resortName)
		? `${resortName} package`
		: `${resortName} Maldives package`

	const OnClick = ({ resortCode, resortName, recommended }) => {
		onPress(
			resortCode,
			resortName,
			recommended,
			packageListingPage ? updatedResortName : resortName,
			itineraryCost,
			campaignItineraryId,
		)
	}
	return (
		<Stack
			key={ind}
			gap={0}
			css={{
				width: '100%',
				marginTop: ind == 0 ? 0 : '$4',
				position: 'relative',
				backgroundColor: '$white',
				'@lg': {
					// height: '232px',
					minHeight: packageListingPage ? 295 : '232px',
					borderRadius: '$3',
					width: '100%',
					border: '$grey01',
					borderStyle: 'solid',
					overflow: 'hidden',
				},
			}}
		>
			{recommended ? (
				<RibbonComponent
					backgroundcolor={'#ffc933'}
					top={'10px'}
					left={'-15px'}
					mobile={'0px'}
				>
					<Flag fill={'#000000'} fontSize={'12px'} />
					<Text
						css={{
							color: '$black',
							fontSize: '$0',
							fontWeight: '$extrabold',
						}}
					>
						Recommended
					</Text>
				</RibbonComponent>
			) : null}

			{hasIncentive && isAdmin ? <SalesIncentive /> : null}

			<Box
				css={{
					width: packageListingPage ? '100%' : '100vw',
					height: '250px',
					position: 'relative',
					'@lg': {
						width: packageListingPage ? '28%' : '250px',
						borderTopLeftRadius: '$3',
						borderBottomLeftRadius: '$3',
						height: '100%',
						overflow: 'hidden',
					},
				}}
			>
				<ImageSlider imageList={images} />
			</Box>

			<Column
				onClick={() => OnClick({ resortCode, resortName, recommended })}
				css={{
					width: '100%',
					cursor: 'pointer',
					padding: '16px',
					'@lg': { height: '100%', flex: 1, justifyContent: 'space-between' },
				}}
			>
				<Column>
					<Box
						css={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							width: '100%',
							gap: '$1',
							'@lg': {
								flexDirection: 'column',
								alignItems: 'flex-start',
								justifyContent: 'center',
							},
						}}
					>
						<Column
							css={{
								display: 'inline-flex',
							}}
						>
							<Text
								css={{
									color: '$black',
									fontWeight: '$extrabold',
									fontSize: '$4',
									width: '100%',
									'@lg': {
										whiteSpace: 'initial',
										fontSize: '$6',
									},
								}}
							>
								{packageListingPage ? updatedResortName : resortName}
							</Text>
						</Column>
					</Box>
					<Column
						css={{
							marginTop: '$2',
							gap: '$3',
						}}
					>
						<Row wrap={'wrap'} gap={2}>
							<Row align={'center'}>
								<Text
									css={{
										fontSize: '$3',
										fontWeight: '$bold',
										color: '$grey08',
									}}
								>
									{starRating}
								</Text>
								<Star fill="#E5B52E" style={{ margin: '0 2px' }} />
								<Text
									css={{
										color: '$grey08',
										fontWeight: '$bold',
										fontSize: '$2',
									}}
								>
									Hotel
								</Text>
							</Row>
							<Row gap={1}>
								<Google fill="#777777" />
								<Text
									css={{
										color: '$grey08',
										fontWeight: '$bold',
										fontSize: '$2',
									}}
								>
									{starRating}/5
								</Text>
							</Row>
							<Row gap={1}>
								<Text
									css={{
										color: '$grey08',
										fontWeight: '$bold',
										fontSize: '$2',
									}}
								>
									{enumToString(availableVillaTypes[0])}
								</Text>
								{availableVillaTypes.length > 1 ? (
									<Text
										css={{
											fontSize: '$2',
											color: '$grey08',
											paddingLeft: '$1',
										}}
									>
										+{availableVillaTypes.length - 1} more room{' '}
										{plural({
											count: availableVillaTypes.length - 1,
											keyword: 'type',
										})}
									</Text>
								) : null}
							</Row>
						</Row>
						<Box
							css={{
								flexWrap: 'wrap',
								display: 'flex',
								flexDirection: 'row',
								gap: '$1',
							}}
						>
							<Row
								css={{
									backgroundColor: '#FFEFD1',
									borderRadius: '$4',
									height: '24px',
									width: 'max-content',
									padding: '4px 8px',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<Text
									css={{
										fontSize: '$1',
										color: '#806519',
										fontWeight: '$bolder',
										textAlign: 'center',
										marginLeft: 2,
										textTransform: 'uppercase',
										letterSpacing: '0.1px',
									}}
								>
									{nights} Nights
								</Text>
							</Row>
							{pills?.length
								? pills?.slice(0, 4).map((a, ind) => {
										return (
											<Row
												key={ind}
												css={{
													backgroundColor: '$primary00',
													borderRadius: '$4',
													height: '24px',
													width: 'max-content',
													paddingRight: '$5',
													paddingLeft: '$2',
													justifyContent: 'center',
													alignItems: 'center',
												}}
											>
												{ind == 3 ? (
													<Plus
														fill={isIxigoPartnersSite ? '#802200' : '#00774F'}
														fontSize={'12px'}
													/>
												) : (
													<Checkmark
														fill={isIxigoPartnersSite ? '#802200' : '#00774F'}
														fontSize={'14px'}
													/>
												)}
												<Text
													css={{
														fontSize: '$1',
														color: '$primary09',
														fontWeight: '$bold',
														textAlign: 'center',
														marginLeft: 2,
														textTransform: 'uppercase',
													}}
												>
													{ind == 3 ? pills.length - 3 + '  more...' : a}
												</Text>
											</Row>
										)
								  })
								: null}
						</Box>
						{activities?.length ? (
							<Column
								css={{
									display: 'none',
									'@lg': {
										display: 'flex',
									},
									'& ul': {
										margin: 0,
										display: 'flex',
										flexDirection: 'column',
										gap: '$2',
										paddingLeft: '0',
									},
									'& li': {
										lineHeight: '21px',
										color: '$grey08',
									},
								}}
							>
								<ListWithShowMore
									minShow={3}
									type={activities.length - 3 > 1 ? 'activities' : 'activity'}
									dataList={activities}
									// onCardClick={e => showGetCostModal(e, pack)}
								/>
							</Column>
						) : null}
					</Column>
				</Column>
				<Box
					css={{
						borderTop: '1.5px solid rgb(242, 242, 242)',
						marginTop: '8px',
						'@lg': { border: 0 },
					}}
				>
					<Row
						css={{
							alignItems: 'flex-end',
							justifyContent: 'flex-end',
							paddingTop: '10px',
							'@lg': {
								paddingTop: '$8',
							},
						}}
					>
						<Box css={{ '@lg': { display: 'none' } }}>
							<Pricecomponent
								strikedCost={strikedCost}
								startsAtPrice={startsAtPrice}
								displayCurrency={displayCurrency}
								currentResortCode={resortCode === currentResortCode}
								paxCount={paxCount}
							/>
						</Box>
					</Row>
				</Box>
			</Column>
			<Box
				css={{
					display: 'none',
					'@lg': {
						width: '206px',
						height: 'auto',
						display: 'flex',
						backgroundColor: '$custom07',
						borderTopRightRadius: '$3',
						borderBottomRightRadius: '$3',
					},
				}}
			>
				<Column
					css={{
						width: '100%',
						justifyContent: 'space-between',
						padding: '16px 24px',
					}}
				>
					<Column>
						<Box
							css={{
								display: 'flex',
								justifyContent: 'flex-start',
							}}
						>
							<Text
								css={{
									textTransform: 'uppercase',
									fontSize: '$2',
									fontWeight: '$bold',
									color: '$grey08',
								}}
							>
								Package Includes
							</Text>
						</Box>
						<Column css={{ marginTop: '$3', gap: '$1' }}>
							{flightIncludes ? <InclusionText text="Return flights" /> : null}
							{!speedBoat && seaPlane ? (
								<InclusionText text={'Seaplane transfer'} />
							) : null}
							{speedBoat ? (
								<InclusionText text={'Speed boat transfer'} />
							) : null}
							<InclusionText text={'24x7 online support'} />
						</Column>
					</Column>
					<Pricecomponent
						strikedCost={strikedCost}
						startsAtPrice={startsAtPrice}
						onPress={() => OnClick({ resortCode, resortName, recommended })}
						displayCurrency={displayCurrency}
						currentResortCode={resortCode === currentResortCode}
						paxCount={paxCount}
					/>
				</Column>
			</Box>
		</Stack>
	)
}
export default Card
